var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/model/removeModel.ts";
import * as api from '@gmini/sm-api-sdk';
export var removeNode = function removeNode(node, userClassifierData) {
  switch (node.type) {
    case 'BimModelReferenceNode':
    case 'BimCategoryReferenceNode':
    case 'BimFamilyReferenceNode':
    case 'BimStandardSizeReferenceNode':
    case 'BimElementReferenceNode':
      api.BimReference.remove.defaultContext.submit({
        classifierId: userClassifierData.id,
        classifierVersion: userClassifierData.version,
        id: node.id
      });
      break;

    case 'UserClassifierEmptyGroupNode':
    case 'UserClassifierGroupWithElementsNode':
    case 'UserClassifierGroupWithGroupsNode':
      api.UserClassifierGroup.remove.defaultContext.submit({
        classifierId: userClassifierData.id,
        parentClassifierVersion: userClassifierData.version,
        id: node.id
      });
      break;

    default:
      break;
  }
};
export var removeAllNodes = function removeAllNodes(request) {
  api.UserClassifier.removeAll.defaultContext.submit(request);
};